import { Annoyed, Frown, HelpCircle, Laugh, Meh, Smile } from "lucide-react";
import type { Sentiment } from "@/shared/types/mention";
import { polarityPalette, type PolarityPalette } from "@/shared/types/polarity";

// Chaveado pela PALETA (papel de cor do domínio de polaridade), não por
// rótulo — os mapas anteriores eram indexados pelos 4 rótulos fixos e
// quebrariam com qualquer polaridade nova ou renomeada no domínio da
// instalação (o ícone virava `undefined` e derrubava o render).
//
// Era chaveado por `tone` até a paleta da marca chegar; `tone` agrupa
// Favorável com Positivo, então metade das polaridades perdia identidade
// própria na tela.
type Palette = PolarityPalette | "unclassified";

// Cheio = intensidade alta, vazado = branda. A forma sozinha já separa
// as quatro, o que importa pra quem não distingue as cores: a diferença
// entre Positivo e Favorável é de tonalidade do mesmo verde.
const paletteIcon: Record<Palette, string> = {
  positive: "▲",
  favorable: "△",
  unfavorable: "▽",
  negative: "▼",
  neutral: "●",
  unclassified: "◆"
};

export const paletteFaceIcon: Record<Palette, typeof Smile> = {
  positive: Laugh,
  favorable: Smile,
  unfavorable: Annoyed,
  negative: Frown,
  neutral: Meh,
  unclassified: HelpCircle
};

type SentimentBadgeProps = {
  /** Rótulo de exibição (`Mention.sentiment`). */
  value: Sentiment;
  /** Valor de wire (`Mention.polarity`) — resolve a cor via domínio. */
  polarity: string | null;
  variant?: "badge" | "face";
};

export function SentimentBadge({ value, polarity, variant = "badge" }: SentimentBadgeProps) {
  const palette: Palette = polarityPalette(polarity);
  if (variant === "face") {
    const Icon = paletteFaceIcon[palette];
    return (
      <span className={`sentiment-face ${palette}`} title={value} aria-label={value}>
        <Icon size={16}/>
      </span>
    );
  }
  return (
    <span className={`badge ${palette}`}>
      <span aria-hidden>{paletteIcon[palette]}</span>
      {value}
    </span>
  );
}
